import { all } from "typed-redux-saga";
import { authSagaWatcher } from "./auth/auth-saga";
import { googleApiClientSaga } from "./google-api-client-saga";
import { googleApiWatcherSaga } from "./google-api-sagas/google-api-saga";

export function* rootSaga() {
  yield all([googleApiClientSaga(), authSagaWatcher(), googleApiWatcherSaga()]);
}
